"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/react";

export function SentryContext(props: {
  sessionID?: string | null;
  email?: string;
  memberID?: string;
}) {
  useEffect(() => {
    Sentry.setUser({
      id: props.sessionID ?? undefined,
      email: props.email,
      username: props.memberID,
    });
  }, [props.sessionID, props.email, props.memberID]);
  return null;
}
